<template>
  <v-data-table flat
    :headers="headers"
    :items="resources"
    class="elevation-2"
    :loading="isLoading"
    :total-items="resourcesCount"
    :rows-per-page-items="limitOptions"
    :pagination.sync="pagination"
  >
    <template slot="items" slot-scope="props">
      <td class="text-xs-left">{{ props.item.id }}</td>
      <td class="text-xs-left">{{ props.item.protocol }}</td>
      <td class="text-xs-left">{{ $n((props.item.bill_amount), 'currency') }}</td>
      <td>{{ $d(formatDueDate(props.item.payment_date), 'short') }}</td>
      <td class="text-xs-left">
        <v-chip :class="setClass(props.item.status)" small text-color="white">
          {{ $t(`status.${props.item.status}`) }}
        </v-chip>
      </td>
      <td>{{ $d(new Date(props.item.created_at), 'short') }}</td>
      <td class="text-xs-left">
        <router-link
          :to="{ name: 'bill-payments-show', params: { id: props.item.id }}"
        >
          Consultar
        </router-link>
      </td>
    </template>
  </v-data-table>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import { changed } from '@/helpers/layout';

export default {
  mounted() {
    this.$store.dispatch('bills/loadBillsPayment', this.filters);
  },
  computed: {
    ...mapGetters({
      resources: 'bills/billsPaymentList',
      resourcesCount: 'bills/billsPaymentResourcesCount',
      limitOptions: 'bills/billsPaymentLimitOptions',
      limit: 'bills/billsPaymentLimit',
      currentPage: 'bills/billsPaymentCurrentPage',
      filters: 'bills/billsPaymentFilter',
      isLoading: 'bills/billsPaymentLoadingData',
      billErrors: "bills/billPaymentError"
    })
  },
  components: {
    NumericRow: () => import('./billsTable/NumericRow.vue'),
    DateRow: () => import('./billsTable/DateRow.vue'),
    LinkRow: () => import('./billsTable/LinkRow.vue'),
    TextRow: () => import('./billsTable/TextRow.vue'),
    ChipRow: () => import('./billsTable/ChipRow.vue'),
    BrandRow: () => import('./billsTable/BrandRow.vue'),
  },
  watch: {
    pagination: function pagination(newPagination, oldPagination) {
      if( changed(newPagination.rowsPerPage, oldPagination.rowsPerPage) ) {
        this.setLimit(newPagination.rowsPerPage);
        this.$store.dispatch('bills/loadBillsPayment', this.filters);
      }
      if( changed(newPagination.page, oldPagination.page) ) {
        this.setCurrentPage(newPagination.page);
        this.$store.dispatch('bills/loadBillsPayment', this.filters);
      }
    },
  },
  methods: {
    ...mapActions({
      setCurrentPage: 'bills/setBillsPaymentCurrentPage',
      setLimit: 'bills/setBillsPaymentLimit',
    }),
    setChipColor(color) {
      return this.$t(`colors.${color}`);
    },
    setClass(status) {
      return `invoice ${status}`;
    },
    formatDueDate(dueDate){
      var dueDate = new Date(dueDate)
      return dueDate.setDate(dueDate.getDate() + 1)
    }
  },
  data() {
    return {
      items: [],
      count: 0,
      pagination: {},
      headers: [
        { text: 'Id Pagamento', value: 'id', sortable: true },
        { text: 'Protocolo', value: 'protocol', sortable: true },
        { text: 'Valor', value: 'bill_amount', sortable: true },
        { text: 'Data Vencimento', value: 'payment_date', sortable: true },
        { text: 'Status', value: 'status', sortable: true },
        { text: 'Pago em', value: 'created_at', sortable: true },
        { text: 'Consultar', value: 'actions', sortable: false },
      ],
    };
  },
};
</script>
<style>
/* Bill Payment Status Colors */
.v-chip.invoice.pending { background-color: #1976D2 !important; } /* primary - blue */
.v-chip.invoice.check_payment { background-color: #29B6F6 !important; } /* info - light blue */
.v-chip.invoice.waiting_payment_day { background-color: #FFC107 !important; } /* warning - yellow */
.v-chip.invoice.paid { background-color: #4CAF50 !important; } /* success - green */
.v-chip.invoice.rejected { background-color: #F44336 !important; } /* error - red */
.v-chip.invoice.unknow { background-color: #9E9E9E !important; } /* secondary - gray */
</style>
